import EventPublisher from '../../utilities/event_publisher';
import Controller from '../../utilities/position-settings-base-controller';
import { find } from 'lodash';

export default class extends Controller {
  connect() {
    window.addEventListener('positions-loaded', this.onPositionsLoaded);
    window.addEventListener('position-selected', this.handlePositionSelected);
    window.addEventListener('selection-cleared', this.handlePositionCleared);
    window.addEventListener('products-loaded', this.onProductsLoaded);
    window.addEventListener('sections-loaded', this.onSectionsLoaded);
    window.addEventListener('section-removed', this.onSectionRemoved);
  }

  onSectionRemoved = event => {
    const { sectionId } = event.detail;
    this.positions.forEach(position => {
      if (position.sectionId === sectionId) position.sectionId = null;
    });
    this.populateSectionOptions();
  }

  handlePositionRemoved = () => {
    const confirmed = confirm(`Are you sure you want to remove ${this.position.identifier}?`); // eslint-disable-line no-alert
    if (!confirmed) return;
    const product = find(this.products, { name: this.position.productName });
    if (product) {
      product.unplaceInventory(this.position.inventoryUnitId);
      this.reRenderProduct(product);
    }
    this.hidePositionSettings();
    this.position.remove();
    EventPublisher.publish('position-removed', { position: this.position });
    if (product) EventPublisher.publish('product-changed', { product: product });
  }

  handleSectionChanged(event) {
    const sectionId = parseInt(event.target.value || 0);
    EventPublisher.publish('section-member-changed', {
      previousSectionId: this.position.sectionId,
      currentSectionId: sectionId,
      positionId: this.position.id
    });
    this.position.sectionId = sectionId;
  }

  handleProductPlacement(event) {
    const { id } = event.target.dataset;
    const product = find(this.products, { id: parseInt(id) });
    const position = product.placeInventory();
    EventPublisher.publish('position-added', { position: position });
    EventPublisher.publish('position-selected', { position: position });
    EventPublisher.publish('product-changed', { product: product });
    this.reRenderProduct(product);
  }

  reRenderProduct(product) {
    const target = document.getElementById(`product-${product.id}`);
    target.outerHTML = this.renderProduct(product);
  }

  // overrides base. adds data-action to element
  renderProduct(product) {
    let disabled = '';
    let dataAction = 'click->templated-layouts--position-settings#handleProductPlacement';
    if (product.hasNoMoreInventories()) {
      disabled = 'opacity-75 cursor-not-allowed';
      dataAction = '';
    }
    return `
      <li class='mb-4 border-b cursor-pointer relative ${disabled}'
        id='product-${product.id}'
        data-id='${product.id}'
        data-action='${dataAction}'>
        <span data-id='${product.id}' class='text-md block mb-1'>${product.name}</span>
        <span data-id='${product.id}' class='text-xs text-gray-500 stats'>
          ${product.totalPlacedInventories} of ${product.totalAvailableInventories} placed
        </span>
      </li>
    `;
  }

}
